module.exports = {"data":{"site":{"siteMetadata":{"title":"Say Something"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"葉寶史，者主實 12…","frontmatter":{"path":"/hihi/","date":"08 November, 2017","title":"標題 123 ABC"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 477
// module chunks = 142629428675168